import apiClient from '../api/client';

/**
 * Device Configuration Service — direct MQTT, no database storage.
 */
const deviceConfigService = {
    /** Get all registered devices for the picker */
    async getDevices() {
        return await apiClient.get('/device-config/devices');
    },

    /** Get device info + latest payload */
    async getDeviceInfo(deviceId) {
        return await apiClient.get(`/device-config/devices/${deviceId}`);
    },

    /** Send config to device via MQTT */
    async sendConfig(deviceId, config, topic = null) {
        return await apiClient.post(`/device-config/devices/${deviceId}/send`, { config, topic });
    },

    /** Send raw MQTT message */
    async sendRawMqtt(topic, payload, qos = 1) {
        return await apiClient.post('/device-config/raw-mqtt', { topic, payload, qos });
    },

    /**
     * Send one or a sequence of plain-text commands to the device's command
     * channel (autopeepal/<imei>/command): RAW-CAN filter ($CANCF...#),
     * SET CANM RAW/J1939, SAVE CONFIG, RESET, SHOW CAN CFG.
     * Pass { command } for one, or { commands: [...] } for a sequence.
     */
    async sendCommand(deviceId, body) {
        return await apiClient.post(`/device-config/devices/${deviceId}/command`, body);
    },

    /** Recent command log (sent + captured device replies) for the console */
    async getCommandLog(deviceId, limit = 50) {
        return await apiClient.get(`/device-config/devices/${deviceId}/commands?limit=${limit}`);
    },

    /** Check MQTT connection status */
    async getMqttStatus() {
        return await apiClient.get('/device-config/mqtt-status');
    },

    /**
     * Config Control Panel — TCU totals, firmware vs the target and the update
     * plan. `target` blank = the highest version recorded on any TCU.
     */
    async getControlPanel(target = '') {
        const t = String(target || '').trim();
        return await apiClient.get(`/device-config/control-panel${t ? `?target=${encodeURIComponent(t)}` : ''}`);
    }
};

export default deviceConfigService;
